import { render, staticRenderFns } from "./Cpaas.vue?vue&type=template&id=2cd20bf6&"
import script from "./Cpaas.vue?vue&type=script&lang=js&"
export * from "./Cpaas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports